import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useSlots } from "vue";
import { ExpansionItemProps } from "@/types";


/**
 * A generic expansion item.
 */
const __default__ = {
  name: "ExpansionItem",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    label: {},
    caption: {}
  },
  setup(__props: any) {

const props = __props;

const slots = useSlots();

return (_ctx: any,_cache: any) => {
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_expansion_item = _resolveComponent("q-expansion-item")!

  return (_openBlock(), _createBlock(_component_q_expansion_item, {
    label: props.label,
    caption: props.caption
  }, _createSlots({
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-my-md transparent" }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default")
        ]),
        _: 3
      })
    ]),
    _: 2
  }, [
    (_unref(slots).icon)
      ? {
          name: "header",
          fn: _withCtx(() => [
            _createVNode(_component_q_item_section, { avatar: "" }, {
              default: _withCtx(() => [
                _renderSlot(_ctx.$slots, "icon")
              ]),
              _: 3
            }),
            _createVNode(_component_q_item_section, { "data-cy": "generic-list-item" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.label), 1)
              ]),
              _: 1
            })
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["label", "caption"]))
}
}

})